<template>
  <ion-card
    :style="{ '--i': index, height: '70px', 'margin-bottom': '14px' }"
    @click="navigateToNextRoute(item)"
  >
    <ion-card-header>
      <div class="title">
        <ion-card-title style="padding-top: 5px">
          <div class="title-progress-circle-container">
            <span class="text-20">
              {{ item.nome.length > 25 ? item.nome.substring(0, 25) + '...' : item.nome }}
            </span>
            <div class="progress-circle">
              <CircleProgressBar
                :value="item.randomPercentage"
                :max="100"
                percentage
                rounded
                :size="40"
                colorUnfilled="#03C03C"
              >
                {{ value }}
              </CircleProgressBar>
            </div>
          </div>
        </ion-card-title>
      </div>
    </ion-card-header>
  </ion-card>
</template>

<script>
import ApiService from '../../common/service.api';
export default {
  props: {
    item: Object,
    index: Number,
  },
  data() {
    return {
      campaignId: null,
    }
    
  },
  methods: {
  /*   navigateToNextRoute(item) {
      this.$emit('navigate', item);
    }, */
    navigateToNextRoute(item) {
  if (item && item.id) {
    const idFolder = item.id; 
    const idCampaign = this.campaignId; 


    ApiService.get(`Journey/GetAppJourney/${idCampaign}?idFolder=${idFolder}`)
      .then((response) => {
        item.children = response.data.blocks; 
        this.itemChildren = item.children; 
        this.$emit('navigate', item);
      })
      .catch((error) => {
        console.error(` ${idFolder} not found`, error);
      });
  } else {
    console.error("id dont valid.");
  }
}
  },
  mounted() {
    const route = this.$route;
    const { id } = route.params;
    this.campaignId = id;
  }

};
</script>
<style scoped>

.progress-circle {
  position: absolute;
  right: -10px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  padding: 5px 10px;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: left;
  justify-content: left;
}
.badge-text {
  font-size: 14px;
  font-weight: 600;
}

ion-card-header {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.4s ease forwards;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lock-status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.lock-status.locked ion-icon {
  color: #FF4757;
}
.lock-status.unlocked ion-icon {
  color: #2ECC71;
}



@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


.btn-disabled {
  background-color: lightgray !important;
  cursor: not-allowed;
  opacity: 0.6;
}


.title-progress-circle-container {
  display: flex;
  align-items: center;
  flex-direction: row
}

.text-20 {
  color: white !important;
}

</style>